(function addBreakpointsToBody() {
    // Array of breakpoint sizes in pixels mapped to corresponding classes
    const breakpoints = [
        {'size': 999999999999, 'class': 'screen-xl'},
        {'size': 1200, 'class': 'screen-lg'},
        {'size': 992, 'class': 'screen-md'},
        {'size': 768, 'class': 'screen-sm'},
        {'size': 576, 'class': 'screen-xs'}
    ];
    
    // Function to toggle classes based on the viewport width and breakpoint sizes
    function toggleClasses() {
        const viewportWidth = window.innerWidth;
        var oldClass = null;
        var newClass = null;
        for (var i in breakpoints) {
            const cls = breakpoints[i].class;
            if (viewportWidth < breakpoints[i].size) {
                newClass = cls;
            }
            if (document.body.classList.contains(cls)) {
                oldClass = cls;
            }
        }
        if (oldClass) {
            document.body.classList.replace(oldClass, newClass);
        } else {
            document.body.classList.add(newClass);
        }
    }
    
    toggleClasses(); // Run initially or after DOMContentLoaded event in HTML file
    
    // Event listener to re-run this function on window resize (optionally)
    window.addEventListener('resize', toggleClasses);
})();